<script setup lang="ts">
import { SellingMethod } from '~/apiClient';

// COMPOSABLES
const { tt } = useTypedI18n();
const sellingMethod = useSlpSellingMethod();
const { totalItems: slpTotalItems, isPending } = useSlpData();
const { navigationItems } = useSlpNavigationItems();

// DATA
const relatedTotalItems = computed(() =>
    sellingMethod.value === SellingMethod.Auction ? slpTotalItems.value[SellingMethod.DirectSale] : slpTotalItems.value[SellingMethod.Auction]
);
const relatedLink = computed(() => navigationItems.value.find(nl => nl.sellingMethod !== sellingMethod.value));
</script>

<template>
    <p class="flex flex-col gap-1 text-base leading-6 font-medium md:flex-row md:gap-4">
        <i18n-t keypath="slp.page.results" tag="span" scope="global">
            <template #total>
                <UIcon v-if="isPending" name="i-svg-spinners-270-ring" class="h-3 w-3" />
                <template v-else>{{ slpTotalItems.current }}</template>
            </template>
        </i18n-t>
        <span class="hidden md:inline">·</span>
        <i18n-t keypath="slp.page.related.base" tag="span" scope="global" class="text-dimmed">
            <template #total>
                <UIcon v-if="isPending" name="i-svg-spinners-270-ring" class="h-3 w-3" />
                <template v-else>{{ relatedTotalItems }}</template>
            </template>
            <template #link>
                <NuxtLink v-if="relatedLink" :to="relatedLink.to" class="underline hover:no-underline">
                    {{ tt(`slp.page.related.link.${relatedLink.sellingMethod}`) }}
                </NuxtLink>
            </template>
        </i18n-t>
    </p>
</template>
